import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import "./assets/styles/tailwind.css";
import "./assets/styles/styles.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import ErrorBoundary from "./modules/ErrorBoundary";
import BoundaryErrorMessage from "./components/BoundaryErrorMessage";

import createStore from "./store";

const { store: storeInstance, persistor } = createStore();
export const store = storeInstance;

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <ErrorBoundary message={() => <BoundaryErrorMessage />}>
        <App />
      </ErrorBoundary>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
